var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instance-container"},[(_vm.baseInfo.dockerStatus == 'failure' || _vm.baseInfo.dockerStatus != 'running')?_c('div',{staticClass:"template-no-data"},[_c('noData',{attrs:{"value":'未安装容器组件，无容器数据'}})],1):_c('div',[_c('rc-table',{ref:"rcTable",attrs:{"tableAttr":_vm.tableAttr}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }